// Firebase Auth (v7) starts Google's iframe helper (apis.google.com, then the project's
// /__/auth/iframe page) as soon as it starts on browsers where a page doesn't keep running in the
// background, which includes every browser on iPhone and iPad (Safari, Chrome...). The helper is
// only used for sign-in with a popup or a redirect, which Rafiki doesn't use (email and password,
// anonymous play). When it can't load (content blocker, private relay, a flaky or missing
// connection) Firebase throws Error("Network Error") from a timer, so it surfaces as an uncaught
// error (PostHog, iOS Chrome, Nov 2026) although nothing the game does is affected.
//
// The message is Firebase's alone: no other code in the game or its libraries uses it.
export const AUTH_IFRAME_ERROR = "Network Error";

export const isAuthIframeNetworkError = (message: any, error?: any): boolean => {
  const fromError = error && typeof error === "object" ? String(error.message || "") : "";
  const text = String(message || "")
    .replace(/^Uncaught\s+/, "")
    .replace(/^Error:\s*/, "");
  return fromError === AUTH_IFRAME_ERROR || text === AUTH_IFRAME_ERROR;
};

let installed = false;
// Ignore that error wherever it surfaces: thrown from a timer (an "error" event) or, should a
// later Firebase reject instead, an unhandled promise rejection. Cancelling the event keeps it
// out of the console and stops it reaching the error reporting (utils.ts initializeErrorReporting,
// which also checks it, in case it runs first).
export const installAuthNetworkErrorGuard = () => {
  if (installed || typeof window === "undefined" || !window.addEventListener) return;
  installed = true;
  window.addEventListener(
    "error",
    (e: ErrorEvent) => {
      if (isAuthIframeNetworkError(e?.message, e?.error)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );
  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    const reason: any = e?.reason;
    if (reason instanceof Error && isAuthIframeNetworkError(reason.message, reason)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });
};

// Tests only.
export const _resetAuthGuardForTests = () => {
  installed = false;
};
